import React from "react";
import { observer } from "mobx-react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { CAPTIONS_LANGUAGES } from "../utils/constants";

class CaptionFormItem extends React.Component {
  render() {
    const { handleOnChange, value } = this.props;

    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="caption-language">Captions</InputLabel>
        <Select
          value={value || CAPTIONS_LANGUAGES[0].value}
          onChange={e => handleOnChange(e.target.value)}
          inputProps={{
            name: "Caption",
            id: "caption"
          }}
        >
          {CAPTIONS_LANGUAGES.map((language, i) => (
            <MenuItem key={i} value={language.value}>
              {language.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default observer(CaptionFormItem);



// WEBPACK FOOTER //
// ./src/components/CaptionFormItem.js